import AddressValidationResourceModel from '../../generated/types/model/resource/AddressValidationResourceModel';

export default class AddressValidationResourceViewModel extends AddressValidationResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
